import Glide from '@glidejs/glide'


class HeroSlider {
      constructor(element) {
            this.glide = null;
            this.element = element;
            this.init();
      }

      init() {   
            this.slider();
            
            window.onload= function(){
                  var glide = this.element.querySelector(".hero.glide__slides");
                  var slides = Array.from(glide.querySelectorAll(".hero .glide__slide--clone"));
                  var arrows = this.element.querySelector(".hero .glide__arrows");

                  if(slides.length <= 2) {
                        arrows.classList.add("hide-arrows");
                  
                        slides.forEach((slide) => {
                              slide.classList.add("two-slides");
                        });

                  } else {
                        arrows.classList.remove("hide-arrows");
                  }

            }.bind(this);    

      }

      slider () {
          var autoplay = this.element.dataset.autoplay === "true" || this.element.dataset.autoplay === "false"
              ? this.element.dataset.autoplay === "true"
              : this.element.dataset.autoplay;

          console.log("autoplay: " + autoplay);

            this.glide = new Glide(this.element, {
                type: 'carousel',
                startAt: 0,
                autoplay: autoplay,
                hoverpause: this.element.dataset.hoverpause === "true",
                perView: this.element.dataset.perview,
                gap: this.element.dataset.gap,
                animationDuration: this.element.dataset.changeduration,
                animationTimingFunc: this.element.dataset.transition,
                peek: {
                    before: this.element.dataset.peek,
                    after: this.element.dataset.peek
                },
                bound: true,
                breakpoints: {
                    800: {
                        perView: 1,
                        gap: 1,
                        peek: 0,
                    }
                }
            }).mount();
      }
}

export default HeroSlider;